import React from "react";
import {Link} from "react-router-dom";
import Modal from "../../Modal";

const LichaamMeisjesBesnijdenis = () => (
    <Modal>
        <div>
            <section id={'meisjesbesnijdenis'}>
                <h1>Meisjesbesnijdenis</h1>

                <p className={'text'}>
                    Meisjesbesnijdenis of vrouwelijke genitale verminking is een vorm van lichamelijke
                    mishandeling. Het is een gebruik waarbij uitwendige geslachtsorganen van meisjes,
                    waaronder de clitoris, (deels) worden besneden of verwijderd.
                </p>

                <p className={'text'}>
                    Ouders kunnen verschillende redenen hebben om hun dochter te laten besnijden,
                    zoals hygiëne, schoonheid en de (veronderstelde) plicht om de maagdelijkheid te
                    beschermen vanuit traditie en religie. Hoewel het in het land van herkomst van deze
                    gezinnen een gangbaar gebruik kan zijn, wordt het in Nederland als mishandeling
                    gezien en is het strafbaar.
                </p>
            </section>
        </div>
    </Modal>
);


export default LichaamMeisjesBesnijdenis;
